import { request } from '@umijs/max';
import * as custom from './custom-services';

export async function getLanguages() {
  return request(`/languages`);
}

export async function getAllAuthButtons() {
  return request(`/bcare/bfmRole/allButton/list`);
}

export async function getNoAuthButtons(roleId: number) {
  return request(`/bcare/bfmRole/roleButton/list/${roleId}`);
}

// 查询企业客户下的根账户
async function getRootAcct(params: any) {
  const { custcode, uniqueAcctId, ...restParams } = params;

  return request(`/bcare/accts/root/${custcode}`, {
    params: { ...restParams, acctId: uniqueAcctId },
  }).then((res) => {
    return (res?.accountList || []).map((item: any) => ({
      ...item,
      key: item.acctId,
      value: item.acctId,
      isLeaf: false,
      uniqueAcctId: item.acctId,
      uniqueParentAcctId: item.parentAcctId,
      uniqueAcctName: item.acctName,
      uniqueAcctCode: item.acctCode,
      uniqueAcctNbr: item.acctNbr,
    }));
  });
}

// 查询系统参数
export async function getSystemParam(params: any) {
  return request('/bcare/sysparam', {
    params,
  });
}

// 查询密码校验规则
export async function getPwdRuleService() {
  return request('/bcare/qryBfmSecurityRules');
}

// 上报数据
export async function sendToZCM(data: any) {
  return request(`/bcare/monitor`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data,
  });
}

// 是否启用埋点
export async function checkZcmMonitorOpen() {
  return request('/bcare/checkZcmMonitorOpen');
}

export default { getRootAcct, ...custom };

// 是否启用二次业务开关
export async function getFeature(params: any) {
  return request(`/bcare/feature/${params}`)
}